import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import Login from "@/views/login/Home.vue";
import AnnuityDetail from "@/views/in-force/AnnuityDetail.vue";
import LifeDetail from "@/views/in-force/LifeDetail.vue";
import Clients from "@/views/clients/Home.vue";
import Client from "@/views/client/Home.vue";
import NotFound from "@/views/not-found/Home.vue";
import { Routes } from "./Routes";
import { accountStore } from "@/store/modules/AccountStore";
import InforceHome from "@/views/in-force/Home.vue";
import ExistingPoliciesHome from "@/views/ExistingPoliciesNoFeed/Home.vue";
import NewBusinessCaseDetail from "@/views/newBusinessCaseDetail/Home.vue";
import AdvisorLandingPage from "@/views/login/AdvisorLandingPage.vue";

Vue.use(VueRouter);

const routes: RouteConfig[] = [
  {
    path: "/login",
    name: Routes.LOGIN,
    component: Login,
  },
  {
    path: "/Welcome",
    name: Routes.POSTLOGIN_LANDINGPAGE,
    component: AdvisorLandingPage,
  },
  {
    path: "/",
    name: Routes.APP,
    component: Clients,
  },
  {
    path: "/client/:id",
    name: Routes.CLIENT,
    component: Client,
  },
  {
    path: "/newbusiness/:id",
    name: Routes.NEW_BUSINESS_CASE_DETAIL,
    component: NewBusinessCaseDetail,
  },
  {
    path: "/existingbusiness",
    name: Routes.EXISTING_BUSINESS,
    component: InforceHome,
  },
  {
    path: "/existingPolicies",
    name: Routes.EXISTING_POLICIES_NOFEED,
    component: ExistingPoliciesHome,
  },
  {
    // will match everything
    path: "*",
    component: NotFound,
  },
  {
    path: "/inforce/annuity/:id",
    name: Routes.INFORCE_ANNUITY_DETAIL,
    component: AnnuityDetail,
  },
  {
    path: "/inforce/life/:id",
    name: Routes.INFORCE_LIFE_DETAIL,
    component: LifeDetail,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

router.beforeEach(async (to, from, next) => {
  if (to.path !== "/login") {
    if (accountStore.isLoggedIn || (await accountStore.getLoggedInUser())) {
      next();
    } else {
      next("/login");
    }
  } else {
    if (!accountStore.isLoggedIn) {
      next();
    } else {
      next("/");
    }
  }
});

export default router;
